// extracted by mini-css-extract-plugin
module.exports = {"ranking_modal":"LeaderboardModal_ranking_modal__J1vHl","ef-box":"LeaderboardModal_ef-box__UkmZv"};